import React, { FC, ReactNode } from 'react'

// @ts-ignore
import styles from './ErrorMessage.scss'

type ErrorProps = {
  children: ReactNode
}

export const ErrorMessage: FC<ErrorProps> = ({ children }) => {
  return (
    <p className={styles.error}>
      {children}
    </p>
  )
}
